import { tokens } from '@/modules/utils/themeUtils';
import { Breakpoints, styled } from '@volkswagen-onehub/components-core';

export const StyledVehicleCards = styled.div(
  ({ theme }) => `
      background-color: ${theme.colors.background.secondary};
      padding: ${theme.size.static250} 0;
  
    @media(min-width: ${Breakpoints.b960}px) {
      padding: ${theme.size.static550} 0;
    }
  `
);

export const StyledVehicleCardsNav = styled.div(
  ({ theme }) => `
      background: ${tokens(theme).globalColors.vLightBeige};
      padding: ${theme.size.static250} 0;
    `
);
